import React from 'react';
import { FsComponentSize } from 'globals/types';
import { CustomTab } from './FsTab.style-elements';
import { getCustomTabStyle } from './FsTab.style';

interface FsTabProps {
  label: string;
  size?: FsComponentSize.M | FsComponentSize.L;
}

const FsTab: React.FC<FsTabProps> = ({
  size = FsComponentSize.M,
  ...props
}) => {
  const customTabStyle = getCustomTabStyle(size);
  return <CustomTab {...props} style={customTabStyle} />;
};

export default FsTab;
